import React from 'react';
import { Box } from '@mui/material';
import AIChat from './AIChat';

function AIChatSidebar({ 
  open, 
  exampleId, 
  question, 
  questionType, 
  studentAnswer, 
  onClose 
}) {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        width: { xs: '100%', md: '500px' },
        transform: 'translateX(0)',
        transition: 'transform 0.3s ease-in-out',
        zIndex: 1000,
        boxShadow: '-4px 0 20px rgba(0,0,0,0.15)',
        borderLeft: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <AIChat
        exampleId={exampleId}
        question={question}
        questionType={questionType}
        studentAnswer={studentAnswer}
        onClose={onClose}
      />
    </Box>
  );
}

export default AIChatSidebar;

